import { createSelector } from 'reselect'

// current artwork selection step 1-5
// current journey step id

export const selectedJourneyId = (state, props) => state.journeyState.getIn([props.galleryId, 'selectedJourney'])
export const currentNavStep = (state, props) => state.journeyState.getIn([props.galleryId, 'currentNavStep'])
export const currentJourneyStepProgress = (state, props) => state.journeyState.getIn([props.galleryId, 'currentJourneyStepProgress'])
export const selectedArtworkIds = (state, props) => state.journeyState.getIn([props.galleryId, 'selectedJourneyArtwork'])
export const selectedJourneyIdForModal = (state, props) => state.journeyState.getIn([props.galleryId, 'uiState', 'selectedJourneyForModal'])
//export const showSelectJourney = (state, props) => state.journeyState.getIn([props.galleryId, 'uiState', 'showSelectJourney'])
export const showAdultOnly = (state, props) => state.journeyState.getIn([props.galleryId, 'uiState', 'showAdultOnly'])
export const selectedArtworkIdForModal = (state, props) => state.journeyState.getIn([props.galleryId, 'uiState', 'selectedArtworkForModal'])
export const personalizedName = (state, props) => state.journeyState.getIn([props.galleryId, 'personalizedName'])
export const showIdleWarning = (state, props) => state.journeyState.getIn([props.galleryId, 'inactive', 'showIdleWarning'])

export const pdfURL = (state, props) => state.journeyState.getIn([props.galleryId, 'pdfFile', 'url'])
export const pdfURLIsFetching = (state, props) => state.journeyState.getIn([props.galleryId, 'pdfFile', 'isFetching'])
export const pdfURLError = (state, props) => state.journeyState.getIn([props.galleryId, 'pdfFile', 'urlError'])
export const pdfPrintingError = (state, props) => state.journeyState.getIn([props.galleryId, 'pdfFile', 'printError'])
export const pdfIsPrinting = (state, props) => state.journeyState.getIn([props.galleryId, 'pdfFile', 'isPrinting'])

export const journeysFiltered = (state, props) => state.journey.get('journeysById').filter(o => o.adult === showAdultOnly(state, props))
export const journeyStepFromProps = (state, props) => props.journeyStep

export const journeys = (state) => state.journey.get('journeysById')
export const journeySteps = (state) => state.journey.getIn(['journeySteps', 'byId'])
export const journeyStepIds = (state) => state.journey.getIn(['journeySteps', 'allIds'])
export const artwork = (state) => state.journey.get('artworkById')
export const kioskMode = (state) => state.journey.get('kioskMode')

export const getSelectedJourney = createSelector(
   [ selectedJourneyId, journeys ],
   ( selectedJourneyId, journeys ) => {
      return journeys.get(selectedJourneyId)
   }
)

export const selectedJourneyForModal = createSelector(
   [ selectedJourneyIdForModal, journeys ],
   ( journeyId, journeys ) => {
      if (journeyId)
         return journeys.get(journeyId)
   }
)

export const getCurrentNavStep = createSelector(
   [currentNavStep],
   ( currentNavStep ) => currentNavStep
)


// returns a list of journey steps for current journey
// should be in the order that they were inserted into the map with
export const getJourneyStepsForSelectedJourney = createSelector(
   [getSelectedJourney, journeySteps],
   ( journey, journeySteps ) => {
      if (journey) {
         const stepIds = journey.get('journey_step_ids')
         const steps = stepIds.map( s => journeySteps.get(s) )
         return steps
      } else {
         return null
      }
   }
)

/* Check to see if artwork selection is finished:
   - All artwork selections have been made
   - count(artwork selection) == count(journey steps)
*/
export const artworkSelectionFinished = createSelector(
   [getJourneyStepsForSelectedJourney, selectedArtworkIds],
   (journeySteps, selectedArtworkIds) => {
      if (journeySteps && selectedArtworkIds)
         return journeySteps.count() === selectedArtworkIds.filter(o => o).count()
      return false
   }
)

// returns the current journey step
export const getCurrentJourneyStep = createSelector(
   [getJourneyStepsForSelectedJourney, currentJourneyStepProgress],
   ( journeySteps, currentStepProgress ) => {
      return (journeySteps ? journeySteps.get(currentStepProgress) : null)
   }
)

export const selectedArtworkForModal = createSelector(
   [selectedArtworkIdForModal, artwork],
   (artworkId, artwork) => {
      if (artworkId)
         return artwork.get(artworkId)
   }
)

// return the artwork for the current step
export const getArtworkForCurrentStep = createSelector(
   [getCurrentJourneyStep, artwork],
   (currentJourneyStep, artwork) => {
      if (currentJourneyStep)
         return currentJourneyStep.get('art_piece_ids').map( a => artwork.get(a))
   }
)

export const journeyStepIdsForCurrentJourney = createSelector(
   [getSelectedJourney],
   (currentJourney) => {
      if (currentJourney)
         return currentJourney.getIn(['journey_step_ids'])
   }
)

/* Given a journey step (0-4), return the selected artwork
   - Look up the id of the journey step at the given position (0-4)
   - Look up the artwork id at that position (may be null)
   - Look up the artwork for the given artwork id
*/ 
export const getSelectedArtworkForJourneyStep = createSelector(
   [journeyStepFromProps, journeyStepIdsForCurrentJourney, artwork, selectedArtworkIds],
   (journeyStep, journeyStepIds, allArtwork, selectedArt) => {
      const index = journeyStepIds.indexOf(journeyStep.id)
      const artWorkId = selectedArt.get(index) // could be undefined or null
      const artwork = allArtwork.get(artWorkId) // could be undefined or null
      return artwork
   }
)

export const getSelectedArtwork = createSelector(
   [artwork, selectedArtworkIds],
   (artwork, selectedArtworkIds) => {
      return selectedArtworkIds.map(id => artwork.get(id))
})


// WEBPACK FOOTER //
// ./src/selectors/journeyState-selectors.js